export const prepareCSVContent = (colDefs, rowData) => {
    const escapeCSV = (cell) => {
      if (cell == null) return '';
      cell = cell.toString();
      if (cell.includes('"') || cell.includes(',') || cell.includes('\n')) {
        return `"${cell.replace(/"/g, '""')}"`;
      }
      return cell;
    };

    const validColDefs = colDefs.filter(col => col.field && col.field !== '_rowId' && col.field !== 'actions');
    const hasRowIdCol = colDefs.some(col => col.field && (col.field.toLowerCase() === 'rowid' || col.field.toLowerCase() === 'rowids' || col.field === '_rowId'));

    const headerFields = hasRowIdCol ? validColDefs.map(col => col.field) : ['Row ID', ...validColDefs.map(col => col.field)];
    const csvHeader = headerFields.map(h => escapeCSV(h)).join(',') + '\n';

    const csvData = rowData.map((row, rowIndex) => {
      const rowIdVal = row._rowId != null ? row._rowId : (rowIndex + 1);
      const rowFields = hasRowIdCol ? validColDefs.map(col => row[col.field]) : [rowIdVal, ...validColDefs.map(col => row[col.field])];
      return rowFields.map(cell => escapeCSV(cell)).join(',');
    }).join('\n');

    const BOM = '\uFEFF';
    const csvContent = BOM + csvHeader + csvData;
    return csvContent;
};

//   const readCSVHeader = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const content = event.target.result;
//         const firstLine = content.split('\n')[0];
//         const headers = firstLine.split(',').map(header => header.trim());
//         resolve(headers);
//       };
//       reader.onerror = (error) => reject(error);
//       reader.readAsText(file);
//     });
// };

// export const downloadCSV = () => {
//     const csvContent = prepareCSVContent();
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     saveAs(blob, 'data.csv');
// };